import { MrfiktivHttpClientProvider } from "@/services/mrfiktiv/mrfiktiv-http-client.provider";
import {
  MrfiktivCreateRepairEstimateDtoGen,
  MrfiktivPageViewModelGen,
  MrfiktivRepairEstimateControllerGetParamsGen,
  MrfiktivRepairEstimateViewModelGen,
  MrfiktivUpdateRepairEstimateDtoGen
} from "../v1/data-contracts";
import { RepairEstimate } from "../v1/RepairEstimate";

/**
 * Communicate with RepairEstimate API
 */
class RepairEstimateService {
  mrfiktivProxy: RepairEstimate;

  /**
   * Construct service
   */
  constructor(mrfiktivHttpClientProvider: MrfiktivHttpClientProvider) {
    this.mrfiktivProxy = new RepairEstimate(mrfiktivHttpClientProvider.client());
  }

  /**
   * Create anRepairEstimate
   */
  async create(
    partnerId: string,
    data: MrfiktivCreateRepairEstimateDtoGen
  ): Promise<MrfiktivRepairEstimateViewModelGen> {
    const RepairEstimate = (await this.mrfiktivProxy.repairEstimateControllerCreate(partnerId, data)).data;

    return RepairEstimate;
  }

  /**
   * Get allRepairEstimate
   */
  async get(
    data: MrfiktivRepairEstimateControllerGetParamsGen
  ): Promise<
    MrfiktivPageViewModelGen & {
      data?: MrfiktivRepairEstimateViewModelGen[];
    }
  > {
    const RepairEstimates = (await this.mrfiktivProxy.repairEstimateControllerGet(data)).data;

    return RepairEstimates;
  }

  /**
   * Get aRepairEstimate
   */
  async getOne(partnerId: string, repairEstimateId: string): Promise<MrfiktivRepairEstimateViewModelGen> {
    const RepairEstimate = (await this.mrfiktivProxy.repairEstimateControllerGetOne(partnerId, repairEstimateId)).data;

    return RepairEstimate;
  }

  /**
   * Update aRepairEstimate
   */
  async update(
    partnerId: string,
    repairEstimateId: string,
    data: MrfiktivUpdateRepairEstimateDtoGen
  ): Promise<MrfiktivRepairEstimateViewModelGen> {
    const RepairEstimate = (await this.mrfiktivProxy.repairEstimateControllerUpdate(partnerId, repairEstimateId, data))
      .data;

    return RepairEstimate;
  }

  /**
   * Delete aRepairEstimate
   */
  async delete(partnerId: string, repairEstimateId: string): Promise<MrfiktivRepairEstimateViewModelGen> {
    const RepairEstimate = (await this.mrfiktivProxy.repairEstimateControllerDelete(partnerId, repairEstimateId)).data;

    return RepairEstimate;
  }
}

/**
 * Communicate withRepairEstimate API
 */
export default new RepairEstimateService(new MrfiktivHttpClientProvider());
